import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { SafelyRenderHtml } from '@src/services';

const FeaturesSection = ({ data }) => {
    const {
        heading,
        intro_html: introHtml,
        items = [],
        cta_label: ctaLabel,
        cta_url: ctaUrl,
    } = data || {};

    return (
        <section id="features-and-benefits" className="col-12 p-0">
            <div className="container-fluid p-0">
                {
                    heading
                    && (
                        <Row className="features-module section-title-blue">
                            <Col>
                                <h2>{SafelyRenderHtml(heading)}</h2>
                            </Col>
                        </Row>
                    )
                }
                {
                    introHtml
                    && (
                        <Row className="features-c">
                            {SafelyRenderHtml(introHtml)}
                        </Row>
                    )
                }
                {
                    items.length > 0
                    && (
                        <Row className="features-c-modules main-container-row">
                            {
                                items.map((item, index) => {
                                    const {
                                        icon,
                                        title,
                                        body,
                                    } = item || {};
                                    const key = `${icon || 'feature'}-${title || index}`;

                                    return (
                                        <Col
                                            key={key}
                                            xs={12}
                                            md={6}
                                            lg={4}
                                            className="p-4"
                                        >
                                            <div className="d-flex align-items-start">
                                                {
                                                    icon
                                                    && (
                                                        <img
                                                            alt=""
                                                            className="me-3 flex-shrink-0"
                                                            src={`/img/icons/${icon}`}
                                                            width={48}
                                                        />
                                                    )
                                                }
                                                <div>
                                                    {title && <h4>{SafelyRenderHtml(title)}</h4>}
                                                    {body && SafelyRenderHtml(body)}
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })
                            }
                        </Row>
                    )
                }
                {
                    ctaLabel && ctaUrl
                    && (
                        <Row className="mt-4 main-container-row">
                            <Col className="text-center">
                                <a
                                    className="ml-button-primary"
                                    href={ctaUrl}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    {SafelyRenderHtml(ctaLabel)}
                                </a>
                            </Col>
                        </Row>
                    )
                }
            </div>
        </section>
    );
};

FeaturesSection.propTypes = {
    data: PropTypes.shape({
        heading: PropTypes.string,
        intro_html: PropTypes.string,
        cta_label: PropTypes.string,
        cta_url: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.shape({
            icon: PropTypes.string,
            title: PropTypes.string,
            body: PropTypes.string,
        })),
    }),
};

export default FeaturesSection;
